import React, { FC } from 'react';
import { isBloggerBusiness } from '../../../utils/accessService';
import { addProtocol } from '../../../utils/addProtocol';
import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../utils/getDomainFromUrl/getDomainFromUrl';
import { useTranslation } from '../../../utils/useTranslation';
import { IconProduct } from '../../icon/IconProduct';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { MediaCover } from '../../media/MediaCover';
import { Price } from '../../price/Price';
import { ProductDomain } from '../../product/ProductDomain/ProductDomain';
import { PostProductTargetLink } from '../PostProductTargetLink/PostProductTargetLink';
import { ProductMonetization } from '../ProductMonetization/ProductMonetization';
import { Card, Title } from './styles';
import { PostProductCardProps } from './types';

export const PostProductCard: FC<PostProductCardProps> = ({
    product,
    business,
    onProductClick,
}) => {
    const t = useTranslation();
    const {
        priceInfo,
        content,
        title,
        url,
        id,
        monetizationEnabled,
        fintechDiscount,
        personalDiscount,
        checkout,
    } = product;

    const media = content[0]?.media;

    const domain = isBloggerBusiness(business?.type)
        ? getDomainFromUrl(product.originalUrl)
        : undefined;

    return (
        <Card as="a" href={addProtocol(url)} onClick={() => onProductClick(id, url)}>
            {monetizationEnabled ? (
                <Box position="absolute" top={1} left={1} zIndex={1}>
                    <ProductMonetization color="white" />
                </Box>
            ) : null}
            <MediaCover ratio={1} overflow="hidden" borderRadius="20px">
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    backgroundColor="var(--always-white)"
                >
                    {media ? (
                        <Image
                            objectFit="contain"
                            width="100%"
                            height="100%"
                            src={buildImageSource(media)}
                            srcSet={buildImageSourceSet(media)}
                        />
                    ) : (
                        <IconProduct size={72} color="var(--control-secondary-background)" />
                    )}
                </Flex>
            </MediaCover>
            <Flex direction="column" p={0.5} spacing={1} flexGrow={1} width="100%">
                <Box>
                    <Title variant="body2" weight="regular">
                        {t(title)}
                    </Title>
                    <Price
                        priceInfo={priceInfo}
                        fintechDiscount={fintechDiscount}
                        personalDiscount={personalDiscount}
                        variant="body"
                        fintechDiscountOptions={{ compact: true }}
                    />
                </Box>
                {domain ? <ProductDomain domain={domain} /> : null}
                <PostProductTargetLink
                    checkout={checkout}
                    onCheckoutAnalytics={
                        checkout?.url
                            ? () => onProductClick(id, checkout.url!, 'product_checkout')
                            : undefined
                    }
                    width="100%"
                    mt="auto"
                />
            </Flex>
        </Card>
    );
};
